module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-next-seo/gatsby-browser.js'),
      options: {"plugins":[],"title":"Gørazd","titleTemplate":"%s | TypeWind","description":"Hello, my name is Gorazd and I'm designer, photographer and videographer","language":"en","canonical":"https://localhost:8000/","openGraph":{"title":"Gørazd","description":"Hello, my name is Gorazd and I'm designer, photographer and videographer","type":"website","locale":"en","url":"https://localhost:8000/"},"twitter":{"handle":"@handle","site":"@site","cardType":"summary_large_image","card":"summary"}},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"short_name":"TypeWind","start_url":"/","background_color":"#BA3442","theme_color":"#BA3442","display":"minimal-ui","icon":"static/images/icon.jpg","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"10946abe3290fc268ddd0398f446b26e"},
    },{
      plugin: require('../node_modules/gatsby-plugin-catch-links/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
